import { InputGroup, TextArea } from "@blueprintjs/core";
import classNames from "classnames";
import { FieldLabel } from "./FieldLabel";
import css from "./NiraTextInput.module.scss";
import { Surface } from "./Surface";

interface NiraTextInputProps {
    readonly label: React.ReactNode;
    readonly value: string;
    readonly onChange: (value: string) => void;
    /** Id for the control, also wired to the label's `htmlFor`. */
    readonly id?: string;
    readonly placeholder?: string;
    /** Render a multi-line textarea instead of a single-line input. */
    readonly multiline?: boolean;
}

/** A field label over a filled, boxed Blueprint text input. */
export const NiraTextInput: React.FC<NiraTextInputProps> = ({
    label,
    value,
    onChange,
    id,
    placeholder,
    multiline = false
}) => {
    const control = multiline ? (
        <TextArea
            fill
            id={id}
            className={classNames(
                css["NiraTextInput-input"],
                css["NiraTextInput-textarea"]
            )}
            placeholder={placeholder}
            value={value}
            onChange={(event) => onChange(event.target.value)}
        />
    ) : (
        <InputGroup
            fill
            id={id}
            inputClassName={css["NiraTextInput-input"]}
            placeholder={placeholder}
            value={value}
            onChange={(event) => onChange(event.target.value)}
        />
    );

    return (
        <div>
            <FieldLabel htmlFor={id}>{label}</FieldLabel>
            <Surface
                tone="tint"
                bordered
                radius="md"
                padding="small"
                className={css["NiraTextInput-control"]}
            >
                {control}
            </Surface>
        </div>
    );
};
